module.exports = __webpack_public_path__ + "static/img/fish42.8a8260d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish42.png
// module id = VLgk
// module chunks = 0